export const createStyles = (theme: any) => ({
  container: {
    position: 'relative',
    width: { xs: 343, sm: 360, md: 560 },
    padding: '1rem 1rem',
    bgcolor: 'background.paper',
    borderRadius: '8px',
    maxHeight: 'calc(100dvh - 2rem)',
    fontFamily: theme?.typography?.fontFamily,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  content: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    minHeight: 0,
    height: '100%',
    pt: '12px',
  },
  title: { fontSize: '18px', fontWeight: 500, mb: '16px' },
  studentList: {
    flex: 1,
    listStyle: 'none',
    m: 0,
    minHeight: 0,
    mt: '12px',
    overflowY: 'auto',
    overscrollBehaviorY: 'contain',
    p: 0,
  },
  actions: {
    display: 'flex',
    flexShrink: 0,
    justifyContent: 'flex-end',
    pt: '16px',
  },
});
